import { createElement } from "react";
import { ChartColumn } from "lucide-react";
import {
  ParetoL1ParamsSchema,
  defaultParetoL1Params,
  type ParetoL1Params,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ParetoL1Widget } from "./Component.js";

import { ParetoL1ExpandedEditor } from "../paretoL1/ExpandedEditor.js";

export const paretoL1Def: WidgetDef<ParetoL1Params> = {
  kind: "paretoL1",
  label: "Level 1 Pareto",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 352, h: 444 },
  defaultParams: defaultParetoL1Params,
  Component: ParetoL1Widget,
  ExpandedComponent: ParetoL1ExpandedEditor,
  storage: "sql",
  schema: ParetoL1ParamsSchema,
  accent: "cyan",
  icon: ChartColumn,
  subtitle: "Pareto distribution",
  defaultRoster: true,
  category: "multi",
  layout: { col: 0, row: 0, width: 352, height: 420 },
  expandable: true,
  renderFooter: (data) => {
    const contributorCount = data.bars.length;
    return {
      left:
        contributorCount > 0
          ? `${contributorCount} contributor${contributorCount === 1 ? "" : "s"}`
          : "No data",
      right: createElement(
        "span",
        { className: "inline-flex items-center gap-1.5 text-pb-text-muted" },
        createElement("span", {
          className: "inline-block w-2.5 h-0.5 bg-pb-text-muted",
          "aria-hidden": true,
        }),
        "Cumulative %",
      ),
    };
  },
};

registerWidget(paretoL1Def);
